import { render } from "./login_copy.vue?vue&type=template&id=479d2c3a&scoped=true"
import script from "./login_copy.vue?vue&type=script&lang=js"
export * from "./login_copy.vue?vue&type=script&lang=js"

import "./login_copy.vue?vue&type=style&index=0&id=479d2c3a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-479d2c3a"]])

export default __exports__